import axios from 'axios'
import {
  host
} from './base.api.js'

const url = host + '/api/page/position/view'

export default {
  // 获得订单列表
  getViews ({
    agentNo,
    area,
    cityId,
    pvAreaId
  }) {
    var http = axios.get(url, {
      params: {
        agentNo,
        area,
        cityId,
        customerId: '',
        pvAreaId,
        t: (new Date()).getTime()
      }
    })
    return http
  }
}



// WEBPACK FOOTER //
// ./src/api/positionview.api.js